<script setup>
import { ref } from 'vue'

defineProps({
  msg: String,
})

const count = ref(0)
</script>

<template>
  <div class="layout-container">
    <aside class="sidebar">
      <nav style="  margin-top: 80px;">
        <router-link to="/" class="menu-item">首页</router-link>
        <router-link to="/partner" class="menu-item">联运商管理</router-link>
        <router-link to="/channel" class="menu-item">渠道管理</router-link>
      </nav>
    </aside>
    
    <main class="content">
      <router-view />
    </main>
  </div>
</template>

<style scoped>
.layout-container {
  display: flex;
  min-height: 100vh;
}

.sidebar {
  width: 10vw;
  background: #f5f5f5;
  padding: 20px;
  border-right: 1px solid #e0e0e0;
}

.menu-item {
  display: block;
  padding: 12px;
  color: #333;
  text-decoration: none;
  border-radius: 4px;
  margin-bottom: 8px;
}

.menu-item:hover {
  background: #e8f0fe;
}

.menu-item.router-link-active {
  background: #d2e3fc;
  font-weight: 500;
}

.content {
  flex-grow: 1;
  width: 90vw;
  overflow: auto;
  padding: 24px;
}

.read-the-docs {
  color: #888;
}
</style>
